import { generateRandomString } from '../../../common/generateID';
import * as itemTypes from '../../../constants/itemTypes/itemTypes';

export default function generateBlockContent(layout) {
    const blockTitle = generateRandomString(12);
    return {
        index: null,
        type: itemTypes.CUSTOMIZED_BLOCK,
        title: blockTitle,
        thumbnailUrl: null,
        content: (() => {
            const columns = [];
            for (let i = 0; i < layout.length; ++i) {
                columns.push({
                    columnIdx: null,
                    size: parseFloat(layout[i]),
                    columnItems: [],
                });
            }
            return {
                columnNum: layout.length,
                backgroundColor: '#ffffff',
                wrapperBackgroundColor: '#ffffff',
                paddingTop: 20,
                paddingBottom: 20,
                structureLocked: false,
                columns,
            };
        })(),
    };
}
